import { ButtonBase } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import Skeleton from '@material-ui/lab/Skeleton'

import useStyles from './styles/index.styles'

export const TemplateTimeIntervalSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div>
        <Skeleton
          variant="circle"
          animation="wave"
          className={classes.counterSkeleton}
        />
      </div>
      <div>
        <Skeleton animation="wave" width="50%" height={20} />
      </div>
      <div>
        <Skeleton animation="wave" width="50%" height={20} />
      </div>
      <div>
        <Skeleton animation="wave" width="50%" height={20} />
      </div>
      <div>
        <Skeleton animation="wave" width="50%" height={20} />
      </div>
      <div className={classes.hidden}>
        <ButtonBase>
          <DeleteIcon />
        </ButtonBase>
      </div>
    </div>
  )
}
